import { iconBgVariants } from '@/components/ui/IconBg'
import { IconV2ArrowLeftOutline } from '@icons/IconV2ArrowLeftOutline'
import { IconV2CorrectOutline } from '@icons/IconV2CorrectOutline'
import { IconV2UploadOutline } from '@icons/IconV2UploadOutline'
import type { VariantProps } from 'class-variance-authority'

type IconBgVariant = NonNullable<VariantProps<typeof iconBgVariants>['variant']>

export const stateMap = {
  Final: {
    name: 'Accepted',
    icon: IconV2CorrectOutline,
    variant: 'success' as IconBgVariant,
    color: 'text-statusgreen-500',
    backgroundColor: 'bg-statusgreen-50',
    borderColor: 'border border-statusgreen-500',
  },
  Uploaded: {
    name: 'Uploaded',
    icon: IconV2UploadOutline,
    variant: 'warning' as IconBgVariant,
    color: 'text-statusyellow-500',
    backgroundColor: 'bg-statusyellow-50',
    borderColor: 'border border-statusyellow-500',
  },
  Discarded: {
    name: 'Discarded',
    icon: IconV2ArrowLeftOutline,
    variant: 'error' as IconBgVariant,
    color: 'text-statusred-500',
    backgroundColor: 'bg-statusred-50',
    borderColor: 'border border-statusred-500',
  },
  None: {
    name: 'Discarded',
    icon: IconV2ArrowLeftOutline,
    variant: 'error' as IconBgVariant,
    color: 'text-statusred-500',
    backgroundColor: 'bg-statusred-50',
    borderColor: 'border border-statusred-500',
  },
}

export const stateOptions = Object.values(stateMap).map((state) => state.name)

export const stateOptionsWithAll = ['All', ...stateOptions]
